export default __webpack_public_path__ + "static/media/gallery_08.d29176d2.jpg";